module.exports = __webpack_public_path__ + "img/4_of_Spades.svg.9e0f6b7b.png";